import { Controller } from 'stimulus';
import getControllerForElement from '@/helpers/getControllerForElement';
import toArray from '@/helpers/toArray';

class ShippingMethodController extends Controller {
  connect() {
    const activeCheckboxes = this.checkboxTargets.filter((target) => target.checked);

    if (activeCheckboxes.length) {
      this.handleShippingChange(activeCheckboxes[0]);
    }
  }

  onShippingChange(event) {
    this.handleShippingChange(event.currentTarget);
  }

  handleShippingChange(element) {
    $.post({
      url: '/api/update-cart-shipping',
      type: 'POST',
      data: {
        shipping_method_id: element.value,
      },
      success: () => {
        this.updateCartSummaries();
      },
    });
  }

  updateCartSummaries() {
    const cartSummaries = toArray(document.querySelectorAll('[data-controller="cart-summary"]'));

    cartSummaries.forEach((summaryElement) => {
      getControllerForElement(this.application, summaryElement, 'cart-summary')
        .then((controller) => {
          controller.update();
        });
    });
  }
}

ShippingMethodController.targets = [
  'checkbox',
];

export default ShippingMethodController;
